import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label
} from "reactstrap";
import Select from "react-select";
import CustomSelectInput from "../../components/common/CustomSelectInput";
import IntlMessages from "../../helpers/IntlMessages";
import { servicePathDefault } from "../../config/defaultValues";
import _axios from "../../libs/axios";
import { NotificationManager } from "../../components/common/react-notifications";

export default class ContactUs extends React.Component {
  constructor(props) {
    super(props);
    this.send = this.send.bind(this);
    this.state = {
      subject: '',
      body:'',
      sender: props.userAdminEmail
    }
  }

  componentDidMount() {
    
  }

  handleChangeSelect = selectedOption => {
    this.setState({ subject: selectedOption });
  };

  send() {
    let err = null;
    if (this.state.subject.label==='' || this.state.body==='') err = 'Please select a reason and enter a summary';
    else if (this.state.sender.indexOf('@') === -1) err = 'Please enter your email';
    
    if (err) {
      NotificationManager.primary(err, "Please complete...", 3000, null, null)
      return;
    }

    //this.props.setLoader(true);
    _axios.post(servicePathDefault + 'tenants/contact/us/', { Subject: this.state.subject.label, Body: this.state.body, Sender: this.state.sender })
      .then(r => {
        this.props.toggleModal();
        //this.props.setLoader(false);
        NotificationManager.success("We have received your message and also sent you a copy to "+this.state.sender+". Please make sure emails from support@getbee.com won't go into SPAM.", "Great!", 3000, null, null)
      })
      .catch(e => {
        //this.props.setLoader(false);
        NotificationManager.error(e, "Somehting bad happened :(", 5000, null, null)
    })
  }

  render() {
    const modalOpen = this.props.modalOpen;
    const toggleModal = this.props.toggleModal;
    return (
      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        wrapClassName="modal-right"
        backdrop="static"
      >
        <ModalHeader toggle={toggleModal}>
          <IntlMessages id="contact.needHelp" />
        </ModalHeader>
        <ModalBody>

          <Label className="mt-4">
            <IntlMessages id="contact.category" />
          </Label>
          <Select
            components={{ Input: CustomSelectInput }}
            className="react-select"
            classNamePrefix="react-select"
            name="form-field-name"
            value={this.state.subject}
            onChange={this.handleChangeSelect}
            options={[
              { label: "Platform issue", value: "Platform issue", key: 0 },
              { label: "Admin portal issue", value: "Admin portal issue", key: 1 },
              { label: "Network issue", value: "Network issue", key: 2 },
              { label: "Other", value: "Other", key: 3 }
            ]}
          />
          <Label className="mt-4">
            <IntlMessages id="contact.issueDesc" />
          </Label>
          <Input type="textarea" name="text" id="issueDesc" value={this.state.body} onChange={e => this.setState({ body: e.target.value })} />


          <Label className="mt-4">
            <IntlMessages id="user.email" />
          </Label>
          <Input type="input" name="sender" id="sender" placeholder="your@email.com" value={this.state.sender} onChange={e => this.setState({ sender: e.target.value })}  />

        </ModalBody>
        <ModalFooter>

          <Button color="primary" onClick={this.send}>
            <IntlMessages id="action.send" />
          </Button>
          <Button color="secondary" outline onClick={toggleModal}>
            <IntlMessages id="action.cancel" />
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}